import { render } from "./LoadXmlModal.vue?vue&type=template&id=edd3fb8a&scoped=true"
import script from "./LoadXmlModal.vue?vue&type=script&lang=js"
export * from "./LoadXmlModal.vue?vue&type=script&lang=js"

import "./LoadXmlModal.vue?vue&type=style&index=0&id=edd3fb8a&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-edd3fb8a"]])

export default __exports__